/**
 * SequenceNode - executes children in order (logical AND).
 * Returns Success only if all children succeed, Failure on first failure.
 */

import { EngineClass } from '../../../../systems/ClassRegistry.js';
import { BehaviorStatus } from '../../BehaviorNode.js';
import { CompositeNode, type CompositeNodeOptions } from '../CompositeNode.js';

import type { Blackboard } from '../../blackboard/Blackboard.js';
@EngineClass('SequenceNode')
export class SequenceNode extends CompositeNode {
  constructor(options: CompositeNodeOptions = {}) {
    super({
      name: 'Sequence',
      ...options
    });
  }

  protected async onExecute(blackboard: Blackboard, deltaTime: number): Promise<BehaviorStatus> {
    // If no children, return success
    if (this.children.length === 0) {
      return BehaviorStatus.Success;
    }

    // Execute children in sequence
    while (this.currentChildIndex < this.children.length) {
      const currentChild = this.children[this.currentChildIndex];
      const childStatus = await currentChild.execute(blackboard, deltaTime);

      switch (childStatus) {
        case BehaviorStatus.Success:
          // Move to next child
          this.currentChildIndex++;
          break;

        case BehaviorStatus.Failure:
          // Sequence fails if any child fails
          this.reset();
          return BehaviorStatus.Failure;

        case BehaviorStatus.Running:
          // Keep running current child
          return BehaviorStatus.Running;
      }
    }

    // All children succeeded
    this.reset();
    return BehaviorStatus.Success;
  }
}